import anime from 'animejs';
import { EASE_IN, EASE_IN_OUT, EASE_OUT, frameToMs } from 'helpers/easings';
import Component from 'navigation/component/Component';
export default class LoadingBar extends Component {
    tl = anime.timeline();
    begin = () => {
        anime.remove(this.refs.bar);
        anime.set(this.refs.bar, { scaleX: 0, transformOrigin: 'left' });
        this.refs.bar.style.transformOrigin = 'left';
        anime({
            targets: this.refs.bar,
            scaleX: [0, 0.3],
            opacity: [1, 1],
            duration: frameToMs(50),
            easing: EASE_OUT
        });
    };
    complete = () => {
        anime.remove(this.refs.bar);
        anime({
            targets: this.refs.bar,
            scaleX: 1,
            duration: frameToMs(50),
            easing: EASE_IN,
            complete: () => {
                this.refs.bar.style.transformOrigin = 'right';
                anime({
                    targets: this.refs.bar,
                    scaleX: 0,
                    duration: frameToMs(50),
                    easing: EASE_IN_OUT
                });
            }
        });
    };
}
